export default "__VITE_ASSET__b97560b5__"